import React from "react";
import type { IButtonProps } from "./types";
import classNames from "classnames";

const LoadingSpinner = () => (
  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
);

const Button: React.FC<IButtonProps> = ({
  label,
  onClick,
  variant = "outlined",
  disabled = false,
  startIcon,
  endIcon,
  style,
  className,
  loading = false,
  loadingText = "",
}) => {
  const variantStyles =
    variant === "outlined"
      ? "text-sm font-redhat-display bg-black border-2 border-primary-1"
      : "bg-primary-1";

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled || loading) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    onClick?.(event);
  };

  return (
    <button
      disabled={disabled || loading}
      onClick={handleClick}
      aria-label="button"
      style={{ ...style }}
      className={classNames(
        "text-white cursor-pointer flex flex-row gap-x-2 items-center font-bold py-2 sm:px-14 px-10 rounded-lg transition-all duration-300 hover:scale-[0.99] active:scale-[0.97] hover:top-0.5 top-0 relative justify-center h-9",
        "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:active:scale-100 disabled:hover:top-0",
        variantStyles,
        className,
      )}
    >
      {startIcon}
      {loading && <LoadingSpinner />}
      {loading ? loadingText : label}
      {!loading && endIcon}
    </button>
  );
};

export default Button;
